import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { PageHeader } from '@/components/layout'
import { Tabs } from '@/components/ui/Tabs'
import { WidgetAssistantsTab } from './components/WidgetAssistantsTab'
import { WidgetInstallationGuide } from './components/WidgetInstallationGuide'
import { WidgetTemplatesTab } from './components/WidgetTemplatesTab'

const TABS = ['assistants', 'templates'] as const

/** The design gives the selected tab charcoal text over a green rule, not brand text. */
const TAB_CLASS = 'px-4 pt-2 pb-3 selected:text-charcoal dark:selected:text-white'

export function WidgetsPage() {
  const { t } = useTranslation()
  const base = 'resources.widgets.hub'
  const [searchParams, setSearchParams] = useSearchParams()

  const requestedTab = searchParams.get('tab')
  const selectedTab = TABS.find((tab) => tab === requestedTab) ?? 'assistants'

  // The tab rule runs to the window edge, so the page cancels the layout's
  // padding and owns the content gutter itself, like the template editor.
  return (
    <div className="-m-4 flex h-full flex-col p-6 pb-20 lg:-m-6 xl:px-16">
      <PageHeader
        title={<span className="text-[30px] leading-[38px] font-medium">{t(`${base}.title`)}</span>}
      />

      <Tabs
        selectedKey={selectedTab}
        onSelectionChange={(key) => setSearchParams({ tab: String(key) })}
      >
        <div className="-mr-6 flex items-center justify-between gap-4 border-b border-gray-200 pr-6 xl:-mr-16 xl:pr-16 dark:border-gray-800">
          <Tabs.List variant="underline" className="border-b-0">
            <Tabs.Trigger id="assistants" size="lg" className={TAB_CLASS}>
              {t(`${base}.tab_assistants`)}
            </Tabs.Trigger>
            <Tabs.Trigger id="templates" size="lg" className={TAB_CLASS}>
              {t(`${base}.tab_templates`)}
            </Tabs.Trigger>
          </Tabs.List>
          <WidgetInstallationGuide />
        </div>

        <Tabs.Content id="assistants" className="pt-[41px] pb-0">
          <WidgetAssistantsTab />
        </Tabs.Content>
        <Tabs.Content id="templates" className="pt-[38px] pb-0">
          <WidgetTemplatesTab />
        </Tabs.Content>
      </Tabs>
    </div>
  )
}

export default WidgetsPage
